import { CancellationToken } from '@cian/http-api';
import { TDeviceType } from '@cian/ui-kit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectHouseId } from 'shared/selectors/houseInfo';
import { selectJsonQuery } from 'shared/selectors/offers';
import { fetchOffersDesktop, fetchOffersMobile } from 'shared/services/fetchOffers';
import { initialState } from 'shared/slices/offers/initialState';
import { EOffersStatus, IOffersState, TOffers } from 'shared/types/offers';
import { IThunkApi } from 'shared/types/redux';
import { equals } from 'ramda';

interface IThunkApiExtended extends IThunkApi {
  rejectValue: boolean;
}

export const getOffers = createAsyncThunk<IOffersState<TOffers>, TDeviceType, IThunkApiExtended>(
  'offers/getOffers',
  async (deviceType, thunkApi) => {
    const { getState, extra: context, rejectWithValue } = thunkApi;

    const { cancellationTokenManager } = context;

    let cancellationToken: CancellationToken | undefined;
    /* istanbul ignore else */
    if (cancellationTokenManager) {
      cancellationToken = cancellationTokenManager.getTokenAndCancelPrevious('getOffers');
    }

    const state = getState();

    const currentJsonQuery = selectJsonQuery(state);
    const jsonQuery = equals(currentJsonQuery, initialState.data.jsonQuery) ? undefined : currentJsonQuery;

    const houseId = selectHouseId(state);

    const fetchOffers = deviceType === 'desktop' ? fetchOffersDesktop : fetchOffersMobile;

    try {
      const response = await fetchOffers(context, {
        parameters: { jsonQuery, houseId },
        config: { cancellationToken },
      });

      /* istanbul ignore next */
      if (response.status === EOffersStatus.Failed) {
        return rejectWithValue(false);
      }

      return response;
    } catch (e) {
      /* istanbul ignore next */
      return rejectWithValue(true);
    }
  },
);
